<template>
  <cargo-ag-grid :grid-options="gridOptions" :column-defs="columnDefs" :row-data="rowData" @gridReady="params=>{gridApi=params.api}" />
</template>

<script>
import { queryOperationRequirementAll } from '@/api/AirExport/operationRequirement'

export default {
  name: 'WarehouseOperationReqDataGrid',
  props: {
    job: { type: Object, required: true }
  },
  data() {
    return {
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        suppressRowClickSelection: true,
        onRowDataChanged: event => {
          console.log('onRowDataChanged')
          const nodes = event.api.rowModel.rowsToDisplay
          console.log(nodes)
          for (const node of nodes) {
            if (node.data.finished) {
              node.setSelected(true)
            }
          }
          this.$emit('callback', [])
        },
        onSelectionChanged: event => {
          const finishedItems = []
          const nodes = event.api.rowModel.rowsToDisplay
          for (const node of nodes) {
            if (node.selected !== node.data.finished) {
              finishedItems.push(node.data)
            }
          }
          this.$emit('callback', finishedItems)
        },
        context: { componentParent: this }
      },
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_OperationRequirement'),
          field: 'contentDescription',
          width: 700,
          pinned: 'left',
          lockPinned: true,
          lockPosition: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_Finished'),
          checkboxSelection: true,
          width: 133
        }
      ],
      rowData: [],
      gridApi: null
    }
  },
  watch: {
    job: {
      immediate: true,
      handler(newVal) {
        this.rowData = []
        if (this.job.uuid) {
          queryOperationRequirementAll({ jobNo: this.job.jobNo, dropRequirementType: 1, opOffice: this.$store.getters.currentOfficeId }).then(res => {
            this.rowData = res.data
          })
        }
      }
    }
  }
}
</script>
